var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateJobTabIconPrivateNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1473 8.26515L16.3715 11.5743C15.7065 14.4322 14.3923 15.5881 11.9223 15.3506C11.5265 15.3189 11.099 15.2476 10.6398 15.1368L9.30982 14.8201C6.00857 14.0364 4.98732 12.4056 5.76315 9.0964L6.53898 5.77932C6.69732 5.1064 6.88732 4.52057 7.12482 4.03765C8.05107 2.12182 9.62648 1.60723 12.2706 2.23265L13.5927 2.5414C16.9098 3.31723 17.9231 4.95598 17.1473 8.26515Z",
    stroke: "#253D87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9225 15.3505C11.4317 15.683 10.8142 15.9601 10.0621 16.2055L8.81128 16.6172C5.66836 17.6305 4.01378 16.7834 2.99253 13.6405L1.97919 10.5134C0.965859 7.37051 1.80503 5.70801 4.94794 4.69468L6.19878 4.28301C6.52336 4.1801 6.83211 4.09301 7.12503 4.0376C6.88753 4.52051 6.69753 5.10635 6.53919 5.77926L5.76336 9.09635C4.98753 12.4055 6.00878 14.0363 9.31003 14.8201L10.64 15.1368C11.0992 15.2476 11.5267 15.3188 11.9225 15.3505Z",
    stroke: "#253D87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0068 6.75293L13.8464 7.72668",
    stroke: "#253D87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23047 9.81689L11.5263 10.4027",
    stroke: "#253D87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateJobTabIconPrivateNotes);
export default __webpack_public_path__ + "static/media/create_job_tab_icon_private_notes.895af0b9bf2ab2a41dfd0bf3b0d858b8.svg";
export { ForwardRef as ReactComponent };